/* Suprimal — Clinical Ivory storefront behaviours. Vanilla, no dependencies. */
(function () {
  'use strict';
  var d = document;
  function qa(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
  function money(cents) {
    var cfg = window.spMoney || {};
    try { return new Intl.NumberFormat(cfg.locale || 'en', { style: 'currency', currency: cfg.currency || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* Header: scrolled state + mobile drawer */
  function initHeader() {
    var h = d.querySelector('.sp-header');
    if (h && !h.__sp) {
      h.__sp = 1;
      var on = function () { h.classList.toggle('is-scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', on, { passive: true }); on();
    }
    qa('[data-sp-menu]').forEach(function (b) {
      if (b.__sp) return; b.__sp = 1;
      var sec = b.closest('.shopify-section') || d;
      var dr = sec.querySelector('[data-sp-drawer]'); if (!dr) return;
      var root = d.documentElement, timer;
      function open() {
        clearTimeout(timer); dr.hidden = false; root.classList.add('sp-sheet-open'); b.setAttribute('aria-expanded', 'true');
        dr.getBoundingClientRect(); dr.classList.add('is-open');
        var f = dr.querySelector('.sp-sheet__close'); if (f) f.focus({ preventScroll: true });
      }
      function close(back) {
        if (dr.hidden) return;
        dr.classList.remove('is-open'); root.classList.remove('sp-sheet-open'); b.setAttribute('aria-expanded', 'false');
        timer = setTimeout(function () { dr.hidden = true; }, 420);
        if (back !== false) b.focus({ preventScroll: true });
      }
      b.addEventListener('click', open);
      dr.addEventListener('click', function (e) {
        if (e.target.closest('[data-sp-close]')) close();
        else if (e.target.closest('a[href]')) close(false);
      });
      d.addEventListener('keydown', function (e) {
        if (dr.hidden) return;
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        var f = qa('a[href],button:not([disabled])', dr).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
      if (window.matchMedia) {
        var mq = window.matchMedia('(min-width: 901px)');
        var wide = function () { if (mq.matches) close(false); };
        if (mq.addEventListener) mq.addEventListener('change', wide); else if (mq.addListener) mq.addListener(wide);
      }
      window.addEventListener('pageshow', function (e) { if (e.persisted) close(false); });
    });
  }

  /* Scroll reveal */
  function initReveal(root) {
    var els = qa('[data-reveal]:not(.is-in)', root);
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    d.documentElement.classList.add('sp-motion');
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Buy box: selling plan cards -> hidden selling_plan + quantity, CTA price, sticky bar */
  function initBuyBox(root) {
    qa('[data-sp-buybox]', root).forEach(function (form) {
      if (form.__sp) return; form.__sp = 1;
      var plan = form.querySelector('[data-sp-plan]'), qty = form.querySelector('[data-sp-qty]'), cta = form.querySelector('[data-sp-cta-price]');
      var sticky = d.querySelector('[data-sp-sticky-price]'), stickyPlan = d.querySelector('[data-sp-sticky-plan]'), stickyDay = d.querySelector('[data-sp-sticky-day]');
      function sync() {
        qa('.sp-option', form).forEach(function (o) {
          var r = o.querySelector('input[type=radio]'); var on = !!(r && r.checked);
          o.classList.toggle('is-selected', on);
          if (!on) return;
          if (plan) { if (r.value) { plan.disabled = false; plan.value = r.value; } else { plan.disabled = true; } }
          if (qty) qty.value = r.getAttribute('data-qty') || 1;
          if (cta) cta.textContent = o.getAttribute('data-price') || '';
          if (sticky) sticky.textContent = o.getAttribute('data-price') || '';
          if (stickyPlan) stickyPlan.textContent = o.getAttribute('data-plan') || '';
          if (stickyDay) stickyDay.textContent = o.getAttribute('data-day') || '';
        });
      }
      form.addEventListener('change', sync); form.addEventListener('submit', sync); sync();
      /* Sticky bar: "Choose your plan" (scrolls to the plans) until the shopper reaches the buy button, "Add to cart" once they scroll past it */
      var bar = d.querySelector('.sp-sticky');
      if (bar) {
        var ctaBox = form.querySelector('.sp-buybox__cta') || form, plans = form.querySelector('.sp-options') || form;
        var btn = bar.querySelector('button'), label = btn ? btn.innerHTML : '', mode = null, ticking = false;
        var setMode = function (m) {
          if (m === mode) return; mode = m;
          if (!m) { bar.setAttribute('hidden', ''); return; }
          bar.removeAttribute('hidden'); bar.classList.toggle('is-jump', m === 'jump');
          if (btn && !btn.disabled) btn.innerHTML = m === 'jump' ? (bar.getAttribute('data-jump-label') || 'Choose your plan') : label;
        };
        var update = function () {
          ticking = false;
          var r = ctaBox.getBoundingClientRect(), vh = window.innerHeight || d.documentElement.clientHeight;
          if (r.bottom < 0) setMode('buy');
          else if (r.top > vh && window.scrollY > 320 && plans.getBoundingClientRect().top > vh * 0.6) setMode('jump');
          else setMode(null);
        };
        window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
        window.addEventListener('resize', update);
        if (btn) btn.addEventListener('click', function (e) {
          if (mode !== 'jump') return;
          e.preventDefault();
          var top = plans.getBoundingClientRect().top + window.scrollY - 84;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }, true);
        update();
      }
    });
  }

  /* Gallery thumbnails */
  function initGallery(root) {
    qa('.sp-gallery', root).forEach(function (g) {
      if (g.__sp) return; g.__sp = 1;
      var slides = qa('.sp-slide', g), thumbs = qa('.sp-gallery__thumbs button', g), dots = qa('.sp-gallery__dots i', g);
      function show(i) {
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        dots.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var track = g.querySelector('.sp-slides');
      if (track) track.addEventListener('scroll', function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); dots.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); }, { passive: true });
    });
  }

  /* Chip filters (collection grid, ingredient index) */
  function initFilters(root) {
    qa('[data-sp-filter]', root).forEach(function (bar) {
      if (bar.__sp) return; bar.__sp = 1;
      var target = d.querySelector(bar.getAttribute('data-sp-filter')); if (!target) return;
      bar.addEventListener('click', function (e) {
        var c = e.target.closest('[data-match]'); if (!c) return;
        var want = c.getAttribute('data-match').toLowerCase().split(/[\s,]+/).filter(Boolean);
        qa('[data-match]', bar).forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        var shown = 0;
        qa('[data-keys]', target).forEach(function (card) {
          var keys = card.getAttribute('data-keys').toLowerCase().split(/\s+/);
          var ok = want.indexOf('all') > -1 || want.some(function (w) { return keys.indexOf(w) > -1; });
          var cell = card.closest('.sp-cell') || card; cell.classList.toggle('is-hidden', !ok); cell.hidden = !ok; if (ok && !card.classList.contains('sp-promo')) shown++;
        });
        var cnt = (bar.closest('.sp-toolbar') || d).querySelector('[data-sp-count]'); if (cnt) cnt.textContent = shown;
      });
    });
    qa('[data-sp-sort]', root).forEach(function (s) {
      if (s.__sp) return; s.__sp = 1;
      s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u.toString(); });
    });
  }

  /* Stack builder: up to three strips, then a plan (90/60/30-day subscription or one-time). Longer plans bill every 2 or 3
     months and deliver one tin a month; free Protocols follow the bag's rule (1 per strip from 2 strips, 2 on 60-day, 3 on 90-day). */
  function initStack(root) {
    qa('[data-sp-stack]', root).forEach(function (el) {
      if (el.__sp) return; el.__sp = 1;
      var MAX = 3;
      var picks = qa('.sp-pick', el), plans = qa('.sp-plan', el);
      var sel = picks.filter(function (p) { return p.getAttribute('data-pre') === '1'; }).map(function (p) { return p.getAttribute('data-variant'); }).slice(0, MAX);
      var byId = {}; picks.forEach(function (p) { byId[p.getAttribute('data-variant')] = p; });
      var start = plans.filter(function (b) { return b.getAttribute('aria-checked') === 'true'; })[0];
      var days = start ? +start.getAttribute('data-days') : 90;
      var slots = el.querySelector('.sp-slots'), msg = el.querySelector('.sp-tiers__msg'), prEl = el.querySelector('[data-sp-stack-pr]');
      var totalS = el.querySelector('[data-total]'), compareS = el.querySelector('[data-compare]'), perS = el.querySelector('[data-per]'), cad = el.querySelector('[data-cadence]');
      var cta = el.querySelector('[data-sp-stack-add]'), err = el.querySelector('[data-sp-stack-error]');
      function pctOf(dd) { var b = plans.filter(function (x) { return +x.getAttribute('data-days') === dd; })[0]; return b ? +b.getAttribute('data-pct') || 0 : 0; }
      function render() {
        picks.forEach(function (p) {
          var on = sel.indexOf(p.getAttribute('data-variant')) > -1;
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
          p.disabled = !on && sel.length >= MAX;
        });
        var html = '';
        for (var i = 0; i < MAX; i++) {
          var p = byId[sel[i]];
          if (p) html += '<div class="sp-slot is-filled" style="--tone:' + p.getAttribute('data-tone') + '"><span class="sp-render">' + p.querySelector('.sp-render').innerHTML + '</span><span class="sp-slot__name">' + p.getAttribute('data-short') + '</span><button class="sp-slot__x" type="button" data-rm="' + sel[i] + '" aria-label="Remove ' + p.getAttribute('data-name') + '"><svg class="sp-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/></svg></button></div>';
          else html += '<div class="sp-slot">' + (i === sel.length ? 'Add a strip' : '') + '</div>';
        }
        slots.innerHTML = html;
        var n = sel.length, base = 0;
        sel.forEach(function (id) { base += +byId[id].getAttribute('data-price'); });
        var pct = days ? pctOf(days) : 0, months = days ? Math.max(1, Math.round(days / 30)) : 1;
        var monthly = Math.round(base * (1 - pct / 100)), billed = monthly * months, compare = base * months;
        plans.forEach(function (b) { var on = +b.getAttribute('data-days') === days; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
        el.setAttribute('data-days', days);
        var perks = days >= 60 ? ' + free shipping' : '';
        msg.innerHTML = !days ? 'Subscribe to save up to <b>' + pctOf(90) + '% off</b>, with free shipping and free Protocols on 60 and 90-day plans.' :
          n === 0 ? 'Add your first strip. Your ' + days + '-day plan saves <b>' + pct + '%</b>' + perks + '.' :
          'Your ' + days + '-day plan: <b>' + pct + '% off' + perks + '</b>.';
        cad.textContent = !days ? 'today' : months > 1 ? 'every ' + months + ' months' : '/ month';
        compareS.textContent = pct && n ? money(compare) : '';
        totalS.textContent = money(billed);
        perS.textContent = n ? (months > 1 ? money(monthly) + ' / month · ' : '') + money(Math.round(monthly / (n * 30))) + ' per strip' : '';
        var bonus = days >= 90 ? 3 : days >= 60 ? 2 : 0, allow = Math.min(7, Math.max(n >= 2 ? n : 0, bonus));
        if (prEl) {
          var t = allow ? '+ ' + allow + ' free Protocol' + (allow > 1 ? 's' : '') + ' (PDF guides). Choose them in your bag.' : n === 1 ? 'Add one more strip for 2 free Protocols.' : '';
          prEl.querySelector('span').textContent = t; prEl.hidden = !t;
        }
        cta.disabled = !n;
      }
      el.addEventListener('click', function (e) {
        var p = e.target.closest('.sp-pick'), rm = e.target.closest('[data-rm]'), pl = e.target.closest('.sp-plan');
        if (p) { var id = p.getAttribute('data-variant'), i = sel.indexOf(id); if (i > -1) sel.splice(i, 1); else if (sel.length < MAX) sel.push(id); render(); }
        if (rm) { sel.splice(sel.indexOf(rm.getAttribute('data-rm')), 1); render(); }
        if (pl) { days = +pl.getAttribute('data-days'); render(); }
      });
      el.addEventListener('keydown', function (e) {
        var pl = e.target.closest && e.target.closest('.sp-plan'); if (!pl) return;
        var k = e.key, i = plans.indexOf(pl);
        if (k !== 'ArrowDown' && k !== 'ArrowRight' && k !== 'ArrowUp' && k !== 'ArrowLeft') return;
        e.preventDefault();
        var nx = plans[(i + ((k === 'ArrowDown' || k === 'ArrowRight') ? 1 : plans.length - 1)) % plans.length];
        days = +nx.getAttribute('data-days'); render(); nx.focus();
      });
      cta.addEventListener('click', function () {
        if (!sel.length) return;
        cta.disabled = true; if (err) err.hidden = true;
        var items = sel.map(function (id) { var it = { id: +id, quantity: 1 }; var plan = days ? byId[id].getAttribute('data-plan' + days) : ''; if (plan) it.selling_plan = +plan; return it; });
        /* a Request object: the subscription app's fetch override would otherwise swap the chosen plan for its own default */
        fetch(new Request((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }))
          .then(function (r) {
            if (!r.ok) throw r;
            if (window.SuprimalCart && d.querySelector('[data-sp-bag]')) { cta.disabled = false; window.SuprimalCart.refresh(true); }
            else location.href = (window.routes && window.routes.cart_url) || '/cart';
          })
          .catch(function () { cta.disabled = false; if (err) err.hidden = false; });
      });
      render();
    });
  }

  /* COA lookup */
  function initCoa(root) {
    qa('[data-sp-coa]', root).forEach(function (f) {
      if (f.__sp) return; f.__sp = 1;
      var data = []; try { data = JSON.parse(f.querySelector('script[type="application/json"]').textContent); } catch (e) {}
      var out = f.querySelector('[data-sp-coa-msg]');
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = (f.querySelector('input').value || '').trim().toLowerCase().replace(/\s+/g, '');
        var hit = data.filter(function (b) { return (b.batch || '').toLowerCase().replace(/\s+/g, '') === v; })[0];
        if (hit && hit.url) { out.className = 'sp-msg sp-msg--ok'; out.innerHTML = 'Found: <a href="' + hit.url + '" target="_blank" rel="noopener">' + (hit.product || 'Lab report') + ' · ' + hit.batch + '</a>'; window.open(hit.url, '_blank', 'noopener'); }
        else { out.className = 'sp-msg sp-msg--error'; out.textContent = f.getAttribute('data-miss') || 'We couldn’t find that batch. Check the number on the base of your tin, or contact us.'; }
      });
    });
  }

  function init(root) { root = root || d; initHeader(); initReveal(root); initBuyBox(root); initGallery(root); initFilters(root); initStack(root); initCoa(root); }
  window.Suprimal = { init: init, money: money };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); }); else init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();